var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlashInactiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9289322,
    y: 10.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 3.0588746 29.3847771)",
    width: 14.1421356,
    height: 1.9997864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0001068,
    y: 29.9289322,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -15.325902 37)",
    width: 1.9997864,
    height: 14.1421356
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,4h-1C12.9716797,4,4,12.9716797,4,24c0,2.8447876,0.6062012,5.5476074,1.6814575,8h2.2180786 C6.6950684,29.5863037,6,26.8757324,6,24c0-9.9248047,8.0751953-18,18-18h1c0.5517578,0,1,0.4482422,1,1v34 c0,0.5517578-0.4482422,1-1,1h-1c-2.8757324,0-5.5863037-0.6950684-8-1.8995361v2.2180786 C18.4523926,43.3937988,21.1552124,44,24,44h1c1.6542969,0,3-1.3457031,3-3V7C28,5.3457031,26.6542969,4,25,4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.2929688,33.2929688 8,38.5859375 2.7070312,33.2929688 1.2929688,34.7070312 6.5859375,40  1.2929688,45.2929688 2.7070312,46.7070312 8,41.4140625 13.2929688,46.7070312 14.7070312,45.2929688 9.4140625,40  14.7070312,34.7070312  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashInactiveMedium);
export default __webpack_public_path__ + "static/media/flash-inactive--medium.a91824266f51810cd3cf1992c5a33efa.svg";
export { ForwardRef as ReactComponent };